import axios from 'axios';

const API_BASE = (process.env.REACT_APP_API_URL || '') + '/api';

const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
  timeout: 180000, // 3 minutes - AI generation takes time
});

// ============================================
// BUSINESS SUBMISSIONS (returns demos!)
// ============================================

export const submitBusiness = async (data) => {
  const payload = {
    name: data.name,
    email: data.email,
    phone: data.phone || '',
    business_name: data.businessName || '',
    business_type: data.businessType || '',
    description: data.description,
    has_website: data.hasWebsite === 'da',
    current_website: data.currentWebsite || '',
    want_demo: data.wantDemo ?? true,
    photos: data.photos || [],
  };
  const response = await api.post('/submissions/', payload);
  return response.data; // Now includes { id, demos: [...], status, ... }
};

export const getSubmissionStatus = async (submissionId) => {
  const response = await api.get(`/submissions/${submissionId}/`);
  return response.data;
};

export const regenerateDemos = async (submissionId) => {
  const response = await api.post(`/submissions/${submissionId}/generate/`);
  return response.data;
};

// ============================================
// EMAIL DEMOS
// ============================================

export const emailDemos = async (submissionId) => {
  const response = await api.post(`/submissions/${submissionId}/send-email/`);
  return response.data;
};

// ============================================
// DEMO HTML URL (for iframes)
// ============================================

export const getDemoHtmlUrl = (submissionId, variantNumber) => {
  return `${process.env.REACT_APP_API_URL || ''}/api/demos/${submissionId}/${variantNumber}/`;
};
// ============================================
// CONTACT
// ============================================

export const sendContactMessage = async (data) => {
  const response = await api.post('/contact/', data);
  return response.data;
};

export default api;

// ============================================
// ORDERS + DEMO CATALOG
// ============================================

export const createOrder = async (data) => {
  const response = await api.post('/orders/', data);
  return response.data;
};

export const checkPromoCode = async ({ code, package: pkg, maintenance }) => {
  const response = await api.post('/promo/check/', { code, package: pkg, maintenance });
  return response.data;
};

export const getCatalogTypes = async () => {
  const response = await api.get('/catalog/');
  return response.data;
};

export const getCatalogDemos = async (businessType) => {
  const response = await api.get(`/catalog/${businessType}/`);
  return response.data;
};

// ============================================
// MINI-GAMES (/joaca)
// ============================================

export const claimGamePrize = async ({ game, name, email }) => {
  const response = await api.post('/joc/premiu/', { game, name, email });
  return response.data; // { percent, code, valid_until }
};
